import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: ['annexesPage'],
        config: {
            field: "Instancia string",
            headerName: getLocalizedString("laborInstance"),
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['annexesPage'],
        config:
        {
            field: 'Tipo string',
            headerName: getLocalizedString("fileType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['annexesPage'],
        config:
        {
            field: 'Nombre archivo',
            headerName: getLocalizedString("digitalFolderNombredelarchivo"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['annexesPage'],
        config:
        {
            field: 'Texto',
            headerName: getLocalizedString("fileDescriptionText"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            field: 'Fecha de registro',
            headerName: getLocalizedString("initialLoadDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            field: 'Hora de registro',
            headerName: getLocalizedString("initialLoadTime"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            field: 'Nombre registro',
            headerName: getLocalizedString("digitalFolderResponsabledelacarga"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            headerName: getLocalizedString("lastUpdateDate"),
            field: 'Fecha de actualizacion',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            headerName: getLocalizedString("lastUpdateTime"),
            field: 'Hora actualizacion',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            field: 'Fecha de vencimiento string',
            headerName: getLocalizedString("annexFechaVencimiento"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            field: 'Situación',
            headerName: getLocalizedString("digitalFolderSituacion"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            headerName: getLocalizedString("signer"),
            field: 'signer',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['annexesPage'],
        config: {
            field: 'Visible',
            headerName: getLocalizedString("visibleColaborador"),
            filter: "agSetColumnFilter",
        }
    },
]